import Header from '../_layouts/public/Header';
import {useEffect} from 'react';
import Footer from '../_layouts/public/Footer';
import AbtCompany from '../_layouts/public/pages/AbtCompany';
import Ourproducts from '../_layouts/public/pages/Ourproducts';
import WelcomeArea from '../_layouts/public/pages/WelcomeArea';

const Home = (props) => {
    const slideCateg = {
        infinite: true,
        speed: 500,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,        
    };

    useEffect(() => {
        document.title = `Home | ${props.company}`;
    }, []);

  return (
    <>
    <Header company={props.company} />

    <WelcomeArea />

    <AbtCompany />

    <Ourproducts />

    {/* <Howitworks />
    
    <Introducing />

    <Ecofriendly />

    <Absorbs />
    
    <OtherProducts />
    
    <Letstalk /> */}
      
    <Footer company={props.company} />
    </>
  );
};
export default Home;